import React from 'react';

const StatCard = ({ title, value, icon, onClick }) => {
  return (
    <div 
      className="bg-white rounded-lg shadow-md p-6 flex justify-between items-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
      onClick={onClick}
    >
      <div>
        <p className="text-gray-600">{title}</p>
        <h3 className="text-2xl font-semibold text-green-800 mt-1">{value}</h3>
      </div>
      <div className="text-4xl text-gray-400">{icon}</div>
    </div>
  );
};

export default StatCard;


